import styles from './DocumentSigning.scss';

import PropTypes from 'prop-types';

import { Component } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import moment from 'moment';

import { loadDocument, removeDocument } from 'part11/actions/documents';
import { SigningIframe } from 'part11/components/SigningIframe/SigningIframe';
import { loadSigningStatements, signDocument } from 'part11/actions/signingStatements';
import LoadingComponent from 'common/permissions/components/LoadingComponent';
import Part11Indicator from 'common/components/Part11Indicator/Part11Indicator';

import { getAuthCredentials } from 'common/util/auth-storage';
import { DEFAULT_DATETIME_INPUT_FORMAT } from 'common/util/dateTime';

export class DocumentSigning extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statementText: null
        };
    }

    componentDidMount() {
        const { binderId, documentId } = this.props;
        this.props.loadSigningStatements();
        this.props.loadDocument(documentId, { binderId, includeRenditions: true });
        this.collapseSidebar(true);
    }

    componentWillUnmount() {
        this.props.removeDocument(this.props.documentId);
        this.collapseSidebar(false);
    }

    change(event) {
        const statements = lodash.keyBy(this.props.signingStatements, 'id');
        this.setState({
            selectedStatement: event.target.value,
            statementText: statements[event.target.value].statement
        });
    }

    collapseSidebar(value) {
        const { setSidebarCollapsed } = this.props;
        if (lodash.isFunction(setSidebarCollapsed)) {
            setSidebarCollapsed(value);
        }
    }

    render() {
        if (!this.props.signingStatements || !this.props.document) {
            return <LoadingComponent />;
        }

        const accessToken = getAuthCredentials().accessToken;
        const loginUrl = `${this.props.originUrl}/sign?access_token=${accessToken}`;
        const signingIframe = this.state.selectedStatement
            ? <SigningIframe url={loginUrl} signDocument={this.signDocument.bind(this)} />
            : null;

        return (
            <div className={styles.container} data-cy="DocumentSigning">
                <div className={styles.pageHeader}>
                    <span>
                        Sign Document
                    </span>
                </div>
                <div className={styles.content} data-cy="DocumentSigning-div">
                    <div className={styles.documentSection}>
                        <div data-cy="DocumentSigning-name">{this.props.document.name}</div>
                        <div data-cy="DocumentSigning-Document">Document Type: {this.props.document.documentType.displayName}</div>
                        <div data-cy="DocumentSigning-Uploaded">Uploaded By: {this.props.document.uploadUser.displayName}</div>
                        <div data-cy="DocumentSigning-Uploaded">Uploaded Date: {moment(this.props.document.uploadDate, DEFAULT_DATETIME_INPUT_FORMAT).format('DD MMM YYYY')}</div>
                    </div>
                    <div className={styles.selectBox} data-cy="DocumentSigning-selectBox">
                        <select onChange={this.change.bind(this)} defaultValue='-1' value={this.state.selectedStatement} className={styles.selectBox}>
                            <option disabled={true} key='0' value='-1'>Select a Statement of Testament</option>
                            {this.props.signingStatements.map(statement => <option key={statement.id} value={statement.id}>{statement.statement}</option>)}
                        </select>
                    </div>
                    <div className={styles.statementText} data-cy="DocumentSigning-statementText">
                        <span data-cy="DocumentSigning-span">
                            {this.state.statementText}
                        </span>
                        {this.state.statementText &&
                            <Part11Indicator className={styles.part11Icon} />
                        }
                    </div>
                    {signingIframe}
                </div>
            </div>
        );
    }

    signDocument(signToken) {
        this.props.signDocument(this.props.documentId, this.state.selectedStatement, signToken, this.props.binderId);
    }
}

DocumentSigning.propTypes = {
    setSidebarCollapsed: PropTypes.func
};

export default connect((state, props) => {
    const studyId = lodash.get(state, 'study.id');
    const studyBinderId = lodash.get(state, 'study.binder.id');
    let binderId = props.params.id;
    
    if (studyBinderId) {
        binderId = studyBinderId;
    }

    return {
        document: lodash.get(state.documents, props.params.documentId, false),
        documentId: props.params.documentId,
        binderId,
        studyId,
        user: state.me,
        signingStatements: state.signingStatements,
        originUrl: lodash.get(state, 'application.config.corsOriginUrl')
    };
}, {
    loadDocument,
    removeDocument,
    loadSigningStatements,
    signDocument
})(DocumentSigning);
